<template>
  <section id="match-news" class="match-news-section">
    <div class="news-shell">
      <div class="news-title">
        <img :src="matchNewsSectionData.titleImage" alt="赛事资讯" />
      </div>

      <div class="news-board">
        <div class="news-panel">
          <div class="news-list">
            <div v-for="item in currentNewsList" :key="item.id" class="news-card"
              :class="{ active: currentActiveId === item.id }" @mouseenter="handleMouseEnter(item.id)"
              @mouseleave="handleMouseLeave" @click="handleCardClick(item)">
              <div class="news-card-content">
                <div class="news-cover">
                  <img :src="item.coverWap || item.cover" :alt="item.title" />
                </div>

                <div class="news-content">
                  <div class="news-card-header">
                    <div class="news-date">{{ item.date }}</div>
                    <div class="news-title-text">{{ item.title }}</div>
                  </div>

                  <div class="news-desc">
                    {{ item.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <MatchPagination
            v-if="newsTotalPages > 1"
            :current-page="newsCurrentPage"
            :total-pages="newsTotalPages"
            size="large"
            @change="changeNewsPage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MatchPagination from '@/components/match/common/MatchPagination.vue'
import { matchNewsList, matchNewsSectionData } from '@/data/match/matchNews'

export default {
  name: 'MatchNewsSection',
  components: { MatchPagination },
  data() {
    const defaultActiveItem = matchNewsList.find(item => item.featured) || matchNewsList[0]
    return {
      matchNewsList,
      matchNewsSectionData,
      newsCurrentPage: 1,
      newsPageSize: 4,
      clickedNewsId: defaultActiveItem ? defaultActiveItem.id : null,
      hoveredNewsId: null,
    }
  },
  computed: {
    currentActiveId() {
      return this.hoveredNewsId === null ? this.clickedNewsId : this.hoveredNewsId
    },
    newsTotalPages() {
      return Math.ceil(this.matchNewsList.length / this.newsPageSize)
    },
    currentNewsList() {
      const startIndex = (this.newsCurrentPage - 1) * this.newsPageSize
      return this.matchNewsList.slice(startIndex, startIndex + this.newsPageSize)
    },
  },
  methods: {
    handleMouseEnter(newsId) { this.hoveredNewsId = newsId },
    handleMouseLeave() { this.hoveredNewsId = null },
    handleCardClick(item) {
      this.clickedNewsId = item.id
      if (item.link) window.open(item.link, '_blank', 'noopener,noreferrer')
    },
    changeNewsPage(page) {
      if (page < 1 || page > this.newsTotalPages) return
      const firstItem = this.matchNewsList[(page - 1) * this.newsPageSize]
      this.newsCurrentPage = page
      this.hoveredNewsId = null
      this.clickedNewsId = firstItem ? firstItem.id : null
    },
  },
}
</script>

<style scoped lang="scss">
.match-news-section {
  min-height: 5.625rem;
  // padding: 0.286458rem 0 0;
  background: #f3f1ee url('@/assets/image/match/pc/match/news-section-bg.png') center top / cover no-repeat;
  box-sizing: border-box;

  .news-shell {
    width: 100%;
    margin: 0 auto;
    height: 5.625rem;
    position: relative;
    top: .260417rem /* 50/192 */;
  }

  .news-title,
  .news-board {
    margin-left: auto;
    margin-right: auto;
  }

  .news-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 6.880208rem;
    max-width: 100%;
    height: 0.869792rem;
    margin: 0 auto;

    img {
      display: block;
      width: 6.880208rem;
      max-width: 100%;
      height: 0.869792rem;
      object-fit: contain;
    }
  }

  .news-board {
    width: 8.151042rem;
    height: 4.328125rem;
    margin-top: 0.026042rem;
    background: url('@/assets/image/match/pc/match/news-frame.png') center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .news-panel {
    width: 6.510417rem;
    height: 3.567708rem;
    display: flex;
    flex-direction: column;
  }

  .news-list {
    width: 100%;
    display: flex;
    flex: none;
    flex-direction: column;
    gap: 0.09375rem;
    height: 3.114584rem;
  }

  .news-card {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 0.666667rem;
    background: rgba(51, 51, 51, 0.9);
    box-sizing: border-box;
    cursor: pointer;
    transition:
      height 0.35s ease,
      padding 0.35s ease,
      background-color 0.35s ease,
      box-shadow 0.35s ease;

    .news-card-content {
      display: flex;

    }

    &.active {
      height: 0.833333rem;
      padding-top: 0.088542rem;
      padding-bottom: 0.088542rem;
      background: rgba(0, 0, 0, 0.8);
      box-shadow: 0 0.020833rem 0.020833rem rgba(0, 0, 0, 0.25);

      .news-cover {
        width: 0.9375rem;
        height: 0.604167rem;
        margin-top: 0;
        margin-right: 0.104167rem;

        img {
          width: 0.9375rem;
          height: 0.604167rem;
        }
      }

      .news-content {
        padding-top: 0.026042rem;
      }

      .news-date {
        color: #ffedbc;
        width: 0.536458rem;
        font-size: 0.104167rem;
        height: 0.145833rem;
        line-height: 0.145833rem;
      }

      .news-title-text {
        color: #ffedbc;
        height: 0.15625rem;
        font-size: 0.130208rem;
        line-height: 0.15625rem;
      }

      .news-desc {
        margin-top: 0.078125rem;
        height: 0.291667rem;
        color: #ffedbc;
        font-size: 0.083333rem;
        line-height: 0.145833rem;
        -webkit-line-clamp: 2;
      }
    }
  }

  .news-cover {
    flex: none;
    width: 0.9375rem;
    height: 0.447917rem;
    margin-top: 0.020833rem;
    margin-right: 0.072917rem;
    transition:
      width 0.35s ease,
      height 0.35s ease,
      margin 0.35s ease,
      margin-top 0.35s ease;

    img {
      display: block;
      width: 0.9375rem;
      height: 0.447917rem;
      object-fit: cover;
      transition: width 0.35s ease, height 0.35s ease;
    }

  }

  .news-content {
    flex: none;
    width: 5.177083rem;
    min-width: 0;
    padding-top: 0.020833rem;
    transition: padding-top 0.35s ease;

  }

  .news-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.125rem;
  }

  .news-date {
    order: 2;
    flex: none;
    width: 0.432292rem;
    height: 0.145833rem;
    color: #ffffff;
    font-size: 0.083333rem;
    line-height: 0.145833rem;
    white-space: nowrap;
    text-align: right;

  }

  .news-title-text {
    flex: none;
    width: 3.073958rem;
    min-width: 3.073958rem;
    height: 0.098958rem;
    color: #ffffff;
    font-size: 0.083333rem;
    font-weight: bold;
    line-height: 0.098958rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition:
      color 0.35s ease,
      height 0.35s ease,
      font-size 0.35s ease,
      line-height 0.35s ease,
      width 0.35s ease,
      min-width 0.35s ease;

  }

  .news-desc {
    width: 100%;
    margin-top: 0.0625rem;
    height: 0.25rem;
    color: #ffffff;
    font-size: 0.072917rem;
    line-height: 0.125rem;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    transition:
      margin-top 0.35s ease,
      color 0.35s ease,
      font-size 0.35s ease,
      line-height 0.35s ease,
      height 0.35s ease;

  }

}

@media (max-width: 750px) {
  .match-news-section {
    min-height: auto;
    padding: 5vw 0 0vw;
    background: transparent;

    .news-shell {
      width: 100%;
      height: auto;
    }

    .news-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .news-board {
      width: 95%;
      height: auto;
      margin-top: 2vw;
      padding: 3vw 0vw 7vw;
      background: none;
      box-sizing: border-box;
      align-items: stretch;
    }

    .news-panel {
      width: 100%;
      height: auto;
    }

    .news-list {
      gap: 2vw;
      height: auto;
    }

    .news-card {
      height: auto;
      min-height: 19vw;
      padding: 2.4vw 2.6vw;
      padding-top: 2.8vw;
        padding-bottom: 2.8vw;

      .news-card-content {
        width: 100%;
        align-items: flex-start;
      }

      &.active {
        height: auto;
        padding-top: 2.8vw;
        padding-bottom: 2.8vw;

        .news-cover {
          width: 25vw;
          height: 16vw;
          margin-top: 0;
          margin-right: 2.6vw;

          img {
            width: 25vw;
            height: 16vw;
          }
        }

        .news-content {
          padding-top: 0;
        }

        .news-date {
          width: auto;
          font-size: 2.6vw;
          height: auto;
          line-height: 3.6vw;
        }

        .news-title-text {
          width: auto;
          min-width: 0;
          height: auto;
          font-size: 3.3vw;
          line-height: 4.4vw;
        }

        .news-desc {
          margin-top: 1.4vw;
          height: auto;
          font-size: 2.6vw;
          line-height: 4vw;
        }
      }
    }

    .news-cover {
      width: 25vw;
      height: 16vw;
      margin-top: 0.5vw;
      margin-right: 2.6vw;

      img {
        width: 25vw;
        height: 16vw;
      }
    }

    .news-content {
      flex: 1;
      width: auto;
      min-width: 0;
      padding-top: 0;
    }

    .news-card-header {
      gap: 2vw;
    }

    .news-date {
      width: auto;
      height: auto;
      font-size: 2.4vw;
      line-height: 3.4vw;
    }

    .news-title-text {
      flex: 1;
      width: auto;
      min-width: 0;
      height: auto;
      font-size: 3vw;
      line-height: 4vw;
    }

    .news-desc {
      margin-top: 1vw;
      height: auto;
      font-size: 2.4vw;
      line-height: 3.8vw;
      -webkit-line-clamp: 3;
    }
  }
}
</style>
